import { generateActionForKey, generateActions } from "../generateActions";
import { eQuanLyDangKyActionsObj } from "../../action-types/quan-ly-dang-ky/IQuanLyDangKyActions";
import { NotifyHelper } from "../../../helpers/toast";

export const quanLyDangKyActions = {
    ...generateActions(eQuanLyDangKyActionsObj, "QUAN_LY_DANG_KY"),
    ...generateActionForKey(eQuanLyDangKyActionsObj, "QUAN_LY_DANG_KY", "LOAD_LOP_TIN_CHI_ERROR", (m) => {
        NotifyHelper.Error(m);
    }),
}